export const environment = {
  production: true,
  apiUrl: 'https://api.uorder.io/',
  googleMapsApiKey: 'AIzaSyAeSK-s1BHd8JnKFOMgz70lCjkag6yKKNw',
};
